import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PropertyImages = ({ images = [], propertyName }) => {
  const maxDots = 5;

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000, // 2 วิ ต่อสไลด์
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
     lazyLoad: "ondemand", 
    appendDots: (dots) => {
      const total = dots.length;
      const visibleDots = total > maxDots ? dots.slice(0, maxDots) : dots;

      return (
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ul
            style={{
              margin: 2,
              paddingLeft: "15px",
              background: "rgba(0, 0, 0, 0.4)",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // ✅ จัดจุดให้อยู่กลางแนวตั้งของพื้นหลัง
              
              minHeight: "18px", // ✅ ให้กรอบดำมีความสูงพอดีจุด
            }}
          >
            {visibleDots.map((dot, i) => (
              <li
                key={i}
                style={{
                  listStyle: "none",
                  display: "flex",
                  alignItems: "center", // ✅ จัดให้อยู่กลางของ li
                }}
              >
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "white",
                    opacity: dot.props.className.includes("slick-active") ? 1 : 0.5,
                    transition: "opacity 0.3s",
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      );
    },
  };

  if (!images || images.length === 0) return null;

  return (
    <div style={{ position: "relative" }}>
      <Slider {...sliderSettings}>
        {images.map((img, idx) => (
    <div key={idx} style={{ width: "100%", height: "200px", overflow: "hidden" }}>
      <img
        src={img}
        alt={`${propertyName || "Property"} ${idx + 1}`}
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
          borderRadius: "8px",
          WebkitTouchCallout: "default", // Safari แสดงเมนู
        }}
         loading="lazy" // ✅ เพิ่มตรงนี้
      />
    </div>
  ))}
      </Slider>
    </div>
  );
};

export default PropertyImages;
